import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltip } from '@mylighthouse/prism-ember';
import type { IconName } from '@mylighthouse/prism-ember/types/components/prism/icon';
import { t } from 'ember-intl';

interface HotelMarketInsightTablesCellsTdStarsSignature {
  Args: {
    displayValue: IconName[];
    value: string;
  };
}

const HotelMarketInsightTablesCellsTdStars = <template>
  <div class="text-200--regular flex flex-row">
    {{#if @value}}
      {{#each @displayValue as |icon|}}
        <PrismIcon @name={{icon}} @size="small" />
      {{/each}}
    {{else}}
      {{t "general.missing"}}
    {{/if}}
  </div>

  <PrismTooltip @side="right" @text={{@value}} />
</template> satisfies TOC<HotelMarketInsightTablesCellsTdStarsSignature>;

export default HotelMarketInsightTablesCellsTdStars;
